var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.isLoading ? _c('Loading') : _vm._e()], 1), _c('a', {
    staticClass: "whatsapp text-white bg-neutral-600 shadow-base transition-all hover:bg-neutral-700 cursor-pointer rounded-full fixed z-60 bottom-8 right-8 w-16 h-16 flex items-center justify-center",
    attrs: {
      "href": "https://api.whatsapp.com/send?phone=6285285890090",
      "target": "_blank"
    }
  }, [_c('Whatsapp', {
    attrs: {
      "width": "32",
      "height": "32"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }